angular
  .module('landingPage')
  .directive('giSpectrumEvent', (spectrumService) => ({
    link($scope, element, attrs) {
      const domEvent = attrs.spectrumDomEvent || 'click';

      const eventListener = () => {
        const eventName = `Item ${domEvent}ed`;

        const eventData = {
          item_name: attrs['giSpectrumEvent'],
          item_position: attrs['spectrumLocation'],
        };

        spectrumService.sendSignal(eventName, eventData);
      };

      element.on(domEvent, eventListener);
    },
  }));
